/**
 * Helpers visuais do módulo resources: estado da garantia (vencida/vencendo)
 * e chips compartilhados entre a página /resources e a aba do cliente.
 */
import type { Equipment } from '@erp/shared';
import { Badge } from '@/components/ui/misc';
import { formatDateBR, todayISO } from '@/features/billing/billing-format';

export type WarrantyState = 'expired' | 'expiring' | null;

export function warrantyState(
  eq: Pick<Equipment, 'warrantyDate' | 'warrantyExpiring'>
): WarrantyState {
  if (!eq.warrantyDate) return null;
  if (eq.warrantyDate < todayISO()) return 'expired';
  return eq.warrantyExpiring ? 'expiring' : null;
}

/** Célula de garantia: dd/mm/aaaa + Badge 'Vencendo'/'Vencida' quando aplicável. */
export function EquipmentWarranty({
  equipment,
}: {
  equipment: Pick<Equipment, 'warrantyDate' | 'warrantyExpiring'>;
}) {
  const state = warrantyState(equipment);
  return (
    <span className="inline-flex items-center gap-1.5 tabular-nums">
      {formatDateBR(equipment.warrantyDate)}
      {state === 'expired' ? (
        <Badge variant="destructive">Vencida</Badge>
      ) : state === 'expiring' ? (
        <Badge variant="warning">Vencendo</Badge>
      ) : null}
    </span>
  );
}

export function EquipmentStatusBadge({ active }: { active: boolean }) {
  return active ? <Badge variant="success">Ativo</Badge> : <Badge>Inativo</Badge>;
}
